import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Navbar from "./Components/Navbar/Navbar";
import Homepage from "./Pages/Homepage/Homepage";
import AboutUs from "./Pages/AboutUs/AboutUs";
import Footer from "./Components/Footer/Footer";
import BoardOfDirectors from "./Pages/BoardOfDirectors/BoardOfDirectors";
import ExecutiveManagement from "./Pages/BoardOfDirectors/BoardOfDirectors1";
import FinancialPerformance from "./Pages/FinancialPerformance/FinancialPerformance";
import WhyBankWithUs from "./Pages/WhyBankWithUs/WhyBankWithUs";
import SavePlusAccount from "./Pages/SavePlusAccount/SavePlusAccount";
import ClassicSavingAcc from "./Pages/ClassicSavingAcc/ClassicSavingAcc";
import PrivilageSavingAcc from "./Pages/PrivilageSavingAcc/PrivilegeSaving";
import TisungoSaving from "./Pages/TisungoSaving/TisungeSavingsAcc";
import PersonalBanking from "./Pages/PersonalBanking/PersonalBanking";
import TonseSavingAcc from "./Pages/TonseSavingAcc/TonseSavingAcc";
import SalaryAccount from "./Pages/SalaryAccount/SalaryAccount";
import IndoHomeLoan from "./Pages/IndoHomeLoan/IndoHomeLoan";
import IndoPersonalLoan from "./Pages/IndoPersonalLoan/IndoPersonalLoan";
import IndoVehicleLoan from "./Pages/IndoVehicleLoan/IndoVehicleLoan";
import BumiFixedDepositAccount from "./Pages/BhumiFixedDepositAccount/BumiFixedDepositAccount";
import IndoFastServe from "./Pages/IndoFastServe/IndoFastServe";
import PrivilegeCurrentAcc from "./Pages/PrivilegeCurrentAcc/PrivilegeCurrentAcc";
import ClassicCurrentAccount from "./Pages/ClassicCurrentAccount/ClassicCurrentAccount";
import SMECurrentAcc from "./Pages/SMECurrentAcc/SMECurrentAccount";
import MSMELoan from "./Pages/MSMELoan/MSMELoan";
import TermLoan from "./Pages/TermLoan/TermLoan";
import AutoFinance from "./Pages/AutoFinance/AutoFinance";
import AgroFinance from "./Pages/AgroFinance/AgroFinance";

import IndoDairyDevelopmentScheme from "./Pages/IndoDairyDevelopmentScheme/IndoDairyDevelopmentScheme";
import IndoDairyProductionScheme from "./Pages/IndoDairyProductionScheme/IndoDairyProductionScheme";

import EquityRelease from "./Pages/EquityRelease/EquityRelease";
import BusinessFinance from "./Pages/BusinessFinance/BusinessFinance";
import WorkingCapitalFinance from "./Pages/WorkingCapitalFinance/WorkingCapitalFinance";
import LeaseRentalDiscounting from "./Pages/LeaseRentalDiscounting/LeaseRentalDiscounting";
import IndoKaSumfinLoan from "./Pages/IndoKaSumfinLoan/IndoKaSumfinLoan";
import IndoWomenPowerLoan from "./Pages/IndoWomenPowerLoan/IndoWomenPowerLoan";
import InternationalBankingForeignBusiness from "./Pages/InternationalBankingForeignBusiness/InternationalBankingForeignBusiness";
import ForexSavings from "./Pages/ForexSavings/ForexSavings";
import ForexRates from "./Pages/ForexRates/ForexRates";
import Career from "./Pages/Career/Career";
import ForexRates1 from "./Pages/ForexRates/ForexRates1";
import WatchLive from "./Pages/WatchLive/WatchLive"
import ForexCurrent from "./Pages/ForexCurrent/ForexCurrent";
import MobileBanking from "./Pages/MobileBanking/MobileBanking";
import WalletBanking from "./Pages/WalletBanking/WalletBanking";
import NetBanking from "./Pages/NetBanking/NetBanking";
import ContactlessCard from "./Pages/ContactlessCard/ContactlessCard";
import EEZY from "./Pages/EEZY/EEZY";
import BusinessBanking from "./Pages/BusinessBanking/BusinessBanking";
import FAQS from "./Pages/FAQS/FAQS";
import Feedback from "./Pages/Feedback/Feedback";
import Disclaimer from "./Pages/IndoVehicleLoan/Disclaimer1";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import DigitalBankingPrivacyPolicy from "./Pages/PrivacyPolicy/DigitalBankingPrivacyPolicy"
import Stories from "./Pages/Stories/Stories";
import Monetarypolicerate from "./Pages/Monetarypolicerate/Monetarypolicerate"
import Monetarypoliceratenovember from "./Pages/Monetarypoliceratenovember/Monetarypoliceratenovember"
import Invitationtotender from "./Pages/Invitationtotender/Invitationtotender"
import Indopremierbanking from "./Pages/Indopremierbanking/Indopremierbanking"
import Officiallaunchofizbhq from "./Pages/Officiallaunchofizbhq/Officiallaunchofizbhq"
import Workerscopensation from "./Pages/Workerscopensation/Workerscopensation"
import Tenderforfitoutworks from "./Pages/Tenderforfitoutworks/Tenderforfitoutworks"
import VendorsSuppliers2024 from "./Pages/VendorsSuppliers2024/VendorsSuppliers2024"
import SaleOfProperties from "./Pages/SaleOfProperties/SaleOfProperties";
import TendorForConsultancy from "./Pages/TendorForConsultancy/TendorForConsultancy";
import Propertiesforsale from "./Pages/Propertiesforsale/Propertiesforsale";
import Propertiesforsale2024 from "./Pages/Propertiesforsale2024/Propertiesforsale";
import Propertiesforsalejune from "./Pages/Propertiesforsalejune/Propertiesforsale";
import AACreditRatings from "./Pages/AACreditRating/AACreditRatings";
import RequestforProposal from "./Pages/RequestforProposal/RequestforProposal";

import TermsandCondition from "./Pages/PrivacyPolicy/TermsandCondition";
import Registrationofvendores from "./Pages/Registrationofvendores/Registrationofvendores"
import Copperminespartnership from "./Pages/Copperminespartnership/Copperminespartnership"
import Memorandumofunderstanding from "./Pages/Memorandumofunderstanding/Memorandumofunderstanding"
import Businessindabaexhibition from "./Pages/Businessindabaexhibition/Businessindabaexhibition"
import Europeanunionexhibition from "./Pages/Europeanunionexhibition/Europeanunionexhibition"
import ContactForm from "./Pages/ContactForm1/ContactForm"
import PremierBanking from "./Pages/PremierBanking/PremierBanking"
import Thankyou from "./Pages/Thankyou";
import AnnualReport2023 from "./Pages/AnnualReport/AnnualReport2023";
import Invitationn from "./Pages/AnnualReport/Invitationn";
import TenderInvitation from "./Pages/AACreditRating/TenderInvitation";
import TenderInvitations from "./Pages/AACreditRating/TenderInvitations";
import Tutorials from "./Components/Tutorials/Tutorials";
import IndoVehicleFinance from "./Pages/AutoFinance/IndoVehicleFinance";
import LatestNews from "./Pages/LatestNews/LatestNews";

import IzbScmVehicleFinance from "./Pages/LatestNewsList/IzbScmVehicleFinance/IzbScmVehicleFinance"
import IzbFundLatestHome from "./Pages/LatestNewsList/IzbFundLatestHome/IzbFundLatestHome";
import IzbAirForce from "./Pages/LatestNewsList/IzbAirForce/IzbAirForce";
import IzbFrontClear from "./Pages/LatestNewsList/IzbFrontClear/IzbFrontClear";
import MtnMomoIzbPartnership from "./Pages/LatestNewsList/MtnMomoIzbPartnership/MtnMomoIzbPartnership"
import IzbAtCOP from "./Pages/LatestNewsList/IzbAtCOP/IzbAtCOP";
import IzbAtFourty from "./Pages/LatestNewsList/IzbAtFourty/IzbAtFourty";
import CelebZambiaSilverJubilee from "./Pages/LatestNewsList/CelebZambiaSilverJubilee/CelebZambiaSilverJubilee";
import VisitorCounter from "./Components/VisitorCounter/VisitorCounter";
import IndoGreenAssetFinanceScheme from "./Pages/IndoGreenAssetFinanceScheme/IndoGreenAssetFinanceScheme";
import IzbPartnerWithActionAuto from "./Pages/LatestNewsList/IzbPartnerWithActionAuto/IzbPartnerWithActionAuto";
import HouseholdContentsInsurance from "./Pages/HouseholdContentsInsurance/HouseholdContentsInsurance";
import HouseOwnersInsurance from "./Pages/HouseOwnersInsurance/HouseOwnersInsurance";
import SmartDevices from "./Pages/Smart Devices/SmartDevices";
import PrivateMotorComprehensiveInsurance from "./Pages/PrivateMotorComprehensiveInsurance/PrivateMotorComprehensiveInsurance";
import IZBSmartChildEducationPlan from "./Pages/IZBSmartChildEducationPlan/IZBSmartChildEducationPlan";
import IZBFlexiFarewellFuneralPlan from "./Pages/IZBFlexiFarewellFuneralPlan/IZBFlexiFarewellFuneralPlan";
import CommercialMotorComprehensiveInsurance from "./Pages/CommercialMotorComprehensiveInsurance/CommercialMotorComprehensiveInsurance";
import IZBFortyAGM from "./Pages/LatestNewsList/IZBFortyAGM/IZBFortyAGM";
import IzbCoffeeAndCars from "./Pages/LatestNewsList/IzbCoffeeAndCars/IzbCoffeeAndCars";
import IzbMouDaz from "./Pages/LatestNewsList/IzbMouDaz/IzbMouDaz";
import IzbAwardedBestCsg from "./Pages/LatestNewsList/IzbAwardedBestCsg/IzbAwardedBestCsg";
import IzbBranchTourSchool from "./Pages/LatestNewsList/IzbBranchTourSchool/IzbBranchTourSchool";
import IZBAndZaffico from "./Pages/LatestNewsList/IZBAndZaffico/IZBAndZaffico";
import LatestTariffsAndCharges from "./Pages/LatestTariffsAndCharges/LatestTariffsAndCharges";
import IZBSupportsCCD from "./Pages/LatestNewsList/IZBSupportsCCD/IZBSupportsCCD";
import IZBHandsOverCDF from "./Pages/LatestNewsList/IZBHandsOverCDF/IZBHandsOverCDF";
import IZBSupportingChembesFuture from "./Pages/LatestNewsList/IZBSupportingChembesFuture/IZBSupportingChembesFuture";
import IZBEmpowerCDFLoans from "./Pages/LatestNewsList/IZBEmpowerCDFLoans/IZBEmpowerCDFLoans";
import IZBk665 from "./Pages/LatestNewsList/IZBk665/IZBk665";
import IzbBudgetSymposium from "./Pages/LatestNewsList/IzbBudgetSymposium/IzbBudgetSymposium";
import IDCIntraGroup from "./Pages/LatestNewsList/IDCIntraGroup/IDCIntraGroup";
import IZBLaunchesIndoDairy from "./Pages/LatestNewsList/IZBLaunchesIndoDairy/IZBLaunchesIndoDairy";
import IZBItalianSchool from "./Pages/LatestNewsList/IZBItalianSchool/IZBItalianSchool";
import IZBInaugralIndaba from "./Pages/LatestNewsList/IZBInaugralIndaba/IZBInaugralIndaba";
import IZBSouthProvinceExpo from "./Pages/LatestNewsList/IZBSouthProvinceExpo/IZBSouthProvinceExpo";
import IZBSouthProvinceFarmerLoans from "./Pages/LatestNewsList/IZBSouthProvinceFarmerLoans/IZBSouthProvinceFarmerLoans";
import BaKopalaPlatinumSponsor from "./Pages/LatestNewsList/BaKopalaPlatinumSponsor/BaKopalaPlatinumSponsor";
import IZBWithZambiaAirways from "./Pages/LatestNewsList/IZBWithZambiaAirways/IZBWithZambiaAirways";
import IZBHealthCare from "./Pages/LatestNewsList/IZBHealthCare/IZBHealthCare";
import IZBHandsOver from "./Pages/LatestNewsList/IZBHandsOver/IZBHandsOver";
import IZBSponsors from "./Pages/LatestNewsList/IZBSponsors/IZBSponsors";
import IZBFra from "./Pages/LatestNewsList/IZBFra/IZBFra";
import IndoZambiaBankAnnounces2025FinancialPerformance from "./Pages/LatestNewsList/IndoZambiaBankAnnounces2025FinancialPerformance/IndoZambiaBankAnnounces2025FinancialPerformance";
import IndoZambiaBankHighlightsSectorSupport from "./Pages/LatestNewsList/IndoZambiaBankHighlightsSectorSupport/IndoZambiaBankHighlightsSectorSupport";


function App() {
  return (
    <>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" exact element={<Homepage />} />
          <Route path="/AboutUs" element={<AboutUs />} />
          <Route path="/BoardOfDirectors" element={<BoardOfDirectors />} />
          <Route path="/ExecutiveManagement" element={<ExecutiveManagement />} />
          <Route path="/FinancialPerformance" element={<FinancialPerformance />} />
          <Route path="/WhyBankWithUs" element={<WhyBankWithUs />} />
          <Route path="/SavePlusAccount" element={<SavePlusAccount />} />
          <Route path="/PersonalBanking" element={<PersonalBanking />} />
          <Route path="/ClassicSavingAcc" element={<ClassicSavingAcc />} />
          <Route path="/PrivilageSavingAcc" element={<PrivilageSavingAcc />} />
          <Route path="/TisungoSaving" element={<TisungoSaving />} />
          <Route path="/TonseSavingAcc" element={<TonseSavingAcc />} />
          <Route path="/SalaryAccount" element={<SalaryAccount />} />
          <Route path="/IndoHomeLoan" element={<IndoHomeLoan />} />
          <Route path="/IndoPersonalLoan" element={<IndoPersonalLoan />} />
          <Route path="/IndoVehicleLoan" element={<IndoVehicleLoan />} />
          <Route path="/BumiFixedDepositAccount" element={<BumiFixedDepositAccount />}/>
          <Route path="/BusinessBanking" element={<BusinessBanking />} />
          <Route path="/IndoFastServe" element={<IndoFastServe />} />
          <Route path="/PrivilegeCurrentAcc" element={<PrivilegeCurrentAcc />} />
          <Route path="/ClassicCurrentAccount" element={<ClassicCurrentAccount />} />
          <Route path="/SMECurrentAcc" element={<SMECurrentAcc />} />
          <Route path="/MSMELoan" element={<MSMELoan />} />
          <Route path="/FAQS" element={<FAQS />} />
          <Route path="/Feedback-Complaint" element={<Feedback />} />
          <Route path="/TermLoan" element={<TermLoan />} />
          <Route path="/AutoFinance" element={<AutoFinance />} />
          <Route path="/IndoVehicleFinance" element={<IndoVehicleFinance />} />
          <Route path="/AgroFinance" element={<AgroFinance />} />

          <Route path="/IndoDairyDevelopmentScheme" element={<IndoDairyDevelopmentScheme />} />
          <Route path="/IndoDairyProductionScheme" element={<IndoDairyProductionScheme />} />


          <Route path="/EquityRelease" element={<EquityRelease />} />
          <Route path="/BusinessFinance" element={<BusinessFinance />} />
          <Route path="/WorkingCapitalFinance" element={<WorkingCapitalFinance />} />
          <Route path="/LeaseRentalDiscounting" element={<LeaseRentalDiscounting />} />
          <Route path="/IndoKaSumfinLoan" element={<IndoKaSumfinLoan />} />
          <Route path="/IndoWomenPowerLoan" element={<IndoWomenPowerLoan />} />
          <Route path="/InternationalBankingForeignBusiness" element={<InternationalBankingForeignBusiness />} />
          <Route path="/ForexSavings" element={<ForexSavings />} />
          <Route path="/ForexRates" element={<ForexRates />} />
          <Route path="/Career" element={<Career />} />
          <Route path="/Thankyou" element={<Thankyou />} />
          <Route path="/ForexRates1" element={<ForexRates1 />} />
          <Route path="/WatchLive" element={<WatchLive />} />
          <Route path="/ForexCurrent" element={<ForexCurrent />} />
          <Route path="/MobileBanking" element={<MobileBanking />} />
          <Route path="/WalletBanking" element={<WalletBanking />} />
          <Route path="/NetBanking" element={<NetBanking />} />
          <Route path="/ContactlessCard" element={<ContactlessCard />} />
          <Route path="/EEZY" element={<EEZY />} />
          <Route path="/Disclaimer" element={<Disclaimer />} />
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/DigitalBankingPrivacyPolicy" element={<DigitalBankingPrivacyPolicy />} />
          <Route path="/Tutorials" element={<Tutorials />} />

          <Route path='/LatestNews' element={<LatestNews />} />
          <Route path='/mtn-momo-izb-partnership' element={<MtnMomoIzbPartnership />} />
          <Route path='/indo-zambia-bank-and-southern-cross-motors-ltd-partner-to-offer-vehicle-finance-to-the-public' element={<IzbScmVehicleFinance />} />
          <Route path='/indo-zambia-bank-to-fund-prospective-home-owners-in-the-hills-property-development' element={<IzbFundLatestHome />} />
          <Route path='/indo-zambia-bank-and-zambia-air-force-forging-stronger-partnerships' element={<IzbAirForce />} />
          <Route path='/indo-zambia-bank-has-signed-an-agreement-with-frontclear' element={<IzbFrontClear />} />
          <Route path='/indo-zambia-bank-is-here-at-cop29' element={<IzbAtCOP />} />
          <Route path='/izb-40-creativity-unleashed' element={<IzbAtFourty />} />
          <Route path='/celebrating-zambia-s-diamond-jubilee-of-independence' element={<CelebZambiaSilverJubilee />} />
          <Route path='/indo-zambia-bank-partners-with-action-auto-zambia-to-extend-vehicle-financing-options' element={<IzbPartnerWithActionAuto />} />
          <Route path='/izb-40th-annual-general-meeting' element={<IZBFortyAGM />} />          
          <Route path='/coffee-cars-with-indo-zambia-bank-in-partnership-with-southern-cross-motors' element={<IzbCoffeeAndCars />} />
          <Route path='/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz' element={<IzbMouDaz />} />
          <Route path='/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024' element={<IzbAwardedBestCsg />} />
          <Route path='/branch-tour-of-international-school-of-lusaka-at-our-corporate-head-office' element={<IzbBranchTourSchool />} />
          <Route path='/indo-zambia-bank-and-zaffico-sign-k200-million-funding-agreement' element={<IZBAndZaffico />} />
          <Route path='/indo-zambia-bank-supports-chawama-constituency-development' element={<IZBSupportsCCD />} />
          <Route path='/izb-hands-over-constituency-development-funds-in-solwezi' element={<IZBHandsOverCDF />} />
          <Route path='/empowering-communities-with-cdf-loans' element={<IZBEmpowerCDFLoans />} />
          <Route path='/supporting-chembe-future-with-youth-women-empowerment' element={<IZBSupportingChembesFuture />} />

          {/*  */}
          <Route path='/indo-zambia-bank-commits-k665-million-to-zescos-green-energy-initiative-in-chadiza' element={<IZBk665 />} />
          <Route path='/izb-and-mofnp-partner-to-host-the-national-symposium-on-2026-budget' element={<IzbBudgetSymposium />} />
          <Route path='/idc-intra-group-market-place' element={<IDCIntraGroup />} />

          <Route path='/izb-launches-indo-dairy-production-finance-scheme-and-indo-dairy-development-finance' element={<IZBLaunchesIndoDairy />} />
          <Route path='/the-italian-school-of-lusakas-educational-tour-of-indo-house-our-corporate-head-office' element={<IZBItalianSchool />} />
          <Route path='/indo-zambia-bank-proudly-participated-in-the-inaugural-higher-education-indaba-2025' element={<IZBInaugralIndaba />} />

          <Route path='/indo-zambia-bank-exhibits-at-the-2025-southern-province-expo' element={<IZBSouthProvinceExpo />} />
          <Route path='/izb-southern-province-mou-for-farmer-loans' element={<IZBSouthProvinceFarmerLoans />} />
          
          <Route path='/ba-kopala-platinum-sponsor-2025-zaffico-marathon' element={<BaKopalaPlatinumSponsor />} />

          <Route path='/indo-zambia-bank-partners-with-zambia-airways-to-elevate-premier-banking-experience' element={<IZBWithZambiaAirways />} />

          <Route path='/indo-zambia-bank-proudly-reaffirmed-its-commitment-to-healthcare-in-zambia' element={<IZBHealthCare />} />

          <Route path='/indo-zambia-bank-donates-medical-equipment-to-ndola-teaching-hospital' element={<IZBHandsOver />} />

          <Route path='/indo-zambia-bank-was-proud-to-sponsor-and-participate-in-the-2026-zambia-economic-forum' element={<IZBSponsors />} />
          <Route path='/indo-zambia-bank-delegation-paid-a-courtesy-call-to-the-food-reserve-agency' element={<IZBFra />} />
          <Route path='/indo-zambia-bank-announces-2025-financial-performance-results' element={<IndoZambiaBankAnnounces2025FinancialPerformance />} />
          <Route path='/indo-zambia-bank-highlights-sector-support-annual-delivery-day' element={<IndoZambiaBankHighlightsSectorSupport />} />
          {/*  */}


          <Route path="/TermsandCondition" element={<TermsandCondition />} />
          <Route path="/Stories" element={<Stories />} />
          <Route path="/NoticeAnnouncements" element={<Stories />} />
          <Route path="/Monetarypolicerate" element={<Monetarypolicerate />} />
          <Route path="/Monetarypoliceratenovember" element={<Monetarypoliceratenovember />} />
          <Route path="/Invitationtotender" element={<Invitationtotender />} />
          <Route path="/Indopremierbanking" element={<Indopremierbanking />} />
          <Route path="/Officiallaunchofizbhq" element={<Officiallaunchofizbhq />} />
          <Route path="/Workerscopensation" element={<Workerscopensation />} />
          <Route path="/Tenderforfitoutworks" element={<Tenderforfitoutworks />} />
          <Route path="/VendorsSuppliers2024" element={<VendorsSuppliers2024 />} />
          <Route path="/SaleOfProperties" element={<SaleOfProperties />} />
          <Route path="/TendorForConsultancy" element={<TendorForConsultancy />} />
          <Route path="/Propertiesforsale" element={<Propertiesforsale />} />
          <Route path="/Propertiesforsale2024" element={<Propertiesforsale2024 />} />
          <Route path="/Propertiesforsalejune" element={<Propertiesforsalejune />} />
          <Route path="/AAcreditratings" element={<AACreditRatings />} />
          <Route path="/AnnualReport" element={<AnnualReport2023/>} />
          <Route path="/Invitationn" element={<Invitationn/>} />
          <Route path="/TenderInvitations" element={<TenderInvitations/>} />

          <Route path="/latest-tariffs-and-charges" element={<LatestTariffsAndCharges/>} />

          <Route path="/RequestforProposal" element={<RequestforProposal />} />

          <Route path="/Registrationofvendores" element={<Registrationofvendores />} />
          <Route path="/Copperminespartnership" element={<Copperminespartnership />} />
          <Route path="/Memorandumofunderstanding" element={<Memorandumofunderstanding />} />
          <Route path="/Businessindabaexhibition" element={<Businessindabaexhibition />} />
          <Route path="/Europeanunionexhibition" element={<Europeanunionexhibition />} />
          <Route path="/ContactForm" element={<ContactForm />} />
          <Route path="/PremierBanking" element={<PremierBanking />} />

          <Route path="/IndoGreenAssetFinanceScheme" element={<IndoGreenAssetFinanceScheme />} />

          {/* Insurance Pages */}
          <Route path="/HouseholdContentsInsurance" element={<HouseholdContentsInsurance />} />
          <Route path="/HouseOwnersInsurance" element={<HouseOwnersInsurance />} />
          <Route path="/SmartDevices" element={<SmartDevices />} />
          <Route path="/PrivateMotorComprehensiveInsurance" element={<PrivateMotorComprehensiveInsurance />} />
          <Route path="/CommercialMotorComprehensiveInsurance" element={<CommercialMotorComprehensiveInsurance />} />
          <Route path="/IZBSmartChildEducationPlan" element={<IZBSmartChildEducationPlan />} />
          <Route path="/IZBFlexiFarewellFuneralPlan" element={<IZBFlexiFarewellFuneralPlan />} />
        
        </Routes>
        <VisitorCounter />
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
